import { render, staticRenderFns } from "./DialogVerifyOrder.vue?vue&type=template&id=b85d5376&scoped=true&"
import script from "./DialogVerifyOrder.vue?vue&type=script&lang=js&"
export * from "./DialogVerifyOrder.vue?vue&type=script&lang=js&"
import style0 from "./DialogVerifyOrder.vue?vue&type=style&index=0&id=b85d5376&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85d5376",
  null
  
)

export default component.exports